// extracted by mini-css-extract-plugin
export default {"container":"EditComponents_container__GUCAR","component":"EditComponents_component__JJNi4","grid":"EditComponents_grid__NlkgJ"};